import { React, useRef, useState } from "react";
import Ripples from "react-ripples";
import { useContract } from "../../../../../../provider/ContractProvider";
import NormalLicense from "../contractType/licenses/Regular/page";
import SpecialLicense from "../contractType/licenses/Special/page";
import NotificationPopup from "../../../../Login/NotificationPopup";
import styled from "styled-components";

const FixedWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1001;
  background: #00000066;
  .logout-confirmation {
    width: 540px;
    background: #ffffff;
    border-radius: 12px;
    padding: 48px 72px;
  }
  .logout-cancel-button {
    border: 1px solid #6b7280;
    border-radius: 8px;
    cursor: pointer;
    height: 48px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .logout-cancel-button:hover {
    border: 1px solid #ffffff;
    background: #d6d6d6;
  }
  .logout-button {
    border: 1px solid #0061ff;
    border-radius: 8px;
    cursor: pointer;
    background-color: #0061ff;
    color: white;
    height: 48px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .logout-button:hover {
    border: 1px solid #0061ffcc;
    background: #0061ffcc;
  }
`;

const Confirm = () => {
  const regularLicenseRef = useRef();
  const specialLicenseRef = useRef();
  const { data, handlePrevious, submitData } = useContract();
  const [loading, setLoading] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  const [BEPopup, setBEPopup] = useState(false);
  const [BEPopupType, setBEPopupType] = useState("");
  const [BEPopupMessage, setBEPopupMessage] = useState("");

  const handleGenerateRegular = async () => {
    await regularLicenseRef.current?.handleGeneratePDF();
  };

  const handleGenerateSpecial = async () => {
    await specialLicenseRef.current?.handleGeneratePDF();
  };

  const handleSubmit = async () => {
    setLoading(true);

    if (data?.agreement_type === "regular") {
      await handleGenerateRegular();
    } else if (data?.agreement_type === "special") {
      await handleGenerateSpecial();
    }

    setBEPopupMessage("infoSuccess");
    setBEPopupType("Success");
    setBEPopup(true);
    await submitData(data);
    setLoading(false);
  };

  return (
    <>
      <div className="fixed top-5 right-5">
        <NotificationPopup
          popup={BEPopup}
          setPopup={setBEPopup}
          type={BEPopupType}
          popupMessage={BEPopupMessage}
          animDirectionTop={true}
        />
      </div>

      <div className="h-full w-full">
        {data?.agreement_type === "regular" ? (
          <NormalLicense ref={regularLicenseRef} />
        ) : data?.agreement_type === "special" ? (
          <SpecialLicense ref={specialLicenseRef} />
        ) : (
          <div className="flex justify-center items-center pt-20">
            <div className=" w-12 h-12 border-4 border-t-transparent border-blue-500 rounded-full animate-spin"></div>
          </div>
        )}
      </div>

      <div className="absolute bottom-0 left-0 w-full flex items-center justify-end pt-8 p-6 gap-6 border-t border-[#E4E7EC] bg-white z-50">
        <div>
          <Ripples color="#FFFFFF40" during={600} className="rounded-lg flex-1">
            <button
              className="contract-button-2 contract-button-2-outlined"
              filled={false}
              onClick={handlePrevious}
            >
              <h5>Буцах</h5>
            </button>
          </Ripples>
        </div>

        <div>
          <Ripples color="#FFFFFF40" during={600} className="rounded-lg flex-1">
            <button
              className={`contract-button-2 contract-button-2-filled ${
                data.is_updatable ? "opacity-50" : ""
              }`}
              onClick={() => setConfirmation(true)}
              disabled={data.is_updatable}
            >
              {" "}
              <h5>Баталгаажуулах</h5>
            </button>
          </Ripples>
        </div>
      </div>
      {confirmation ? (
        <FixedWrapper
          onClick={() => {
            setConfirmation(false);
          }}
        >
          <div className="flex flex-col items-center justify-center w-full h-full">
            <div className="logout-confirmation">
              <h5
                className="font-medium text-center pb-8"
                style={{ fontSize: "28px", lineHeight: "2rem" }}
              >
                Гэрээний мэдээлэл
              </h5>
              <h5 className="text-base text-center pb-8">
                Та баталгаажуулахдаа итгэлтэй байна уу?
              </h5>
              <div className="flex flex-row gap-8 justify-around">
                <Ripples
                  color="#FFFFFF40"
                  during={600}
                  className="w-full h-full rounded-lg"
                >
                  <div
                    className="logout-button"
                    onClick={() => {
                      handleSubmit();
                      setTimeout(() => {
                        setConfirmation(false);
                      }, [200]);
                    }}
                  >
                    <h5 className="text-sm font-medium py-2 px-4">Тийм</h5>
                  </div>
                </Ripples>
                <Ripples
                  color="#0061FF40"
                  during={600}
                  className="w-full h-full rounded-lg"
                >
                  <div
                    className="logout-cancel-button"
                    onClick={() => {
                      setConfirmation(false);
                    }}
                  >
                    <h5 className="text-sm font-medium py-2 px-4">Үгүй</h5>
                  </div>
                </Ripples>
              </div>
            </div>
          </div>
        </FixedWrapper>
      ) : (
        ""
      )}
    </>
  );
};
export default Confirm;
